import React, { Component } from "reactn";
import { app } from "js/namespaces";
import { $, Backbone, _ } from "js/vendor";
import { blendColors } from "js/core/utilities/utilities";

export class ColorPalette extends Component {
    render() {
        let colors = [];

        if (this.props.showAuto) {
            colors.push({
                name: "auto",
                color: this.props.autoColor.toRgbString() || app.currentTheme.palette.getColor(app.currentCanvas.getSlideColor()).toRgbString(),
            });
        }

        if (this.props.showNone) {
            colors.push({ name: "none", color: "none" });
        }

        if (this.props.showTextColors) {
            colors.push({
                name: "primary_dark",
                color: app.currentTheme.palette.getForeColor("primary_dark", null, null).toRgbString()
            });
            colors.push({
                name: "secondary_dark",
                color: app.currentTheme.palette.getForeColor("secondary_dark", null, null).toRgbString()
            });
            colors.push({
                name: "primary_light",
                color: app.currentTheme.palette.getForeColor("primary_light", null, null).toRgbString()
            });
            colors.push({
                name: "secondary_light",
                color: app.currentTheme.palette.getForeColor("secondary_light", null, null).toRgbString()
            });
        }

        if (this.props.showBackgroundColors) {
            colors.push({
                name: "background_light",
                color: app.currentTheme.palette.getForeColor("background_light", null, app.currentCanvas.getBackgroundColor()).toRgbString()
            });
            colors.push({
                name: "background_dark",
                color: app.currentTheme.palette.getForeColor("background_dark", null, app.currentCanvas.getBackgroundColor()).toRgbString()
            });
        }

        if (this.props.showLightDark) {
            let shade;

            if (app.currentCanvas.getBackgroundColor().name == "background_light" || app.currentCanvas.getBackgroundColor().name == "background_accent") {
                shade = "dark";
            } else {
                shade = "light";
            }

            colors.push({
                name: `primary_${shade}`,
                color: app.currentTheme.palette.getForeColor(`primary_${shade}`, null, app.currentCanvas.getBackgroundColor()).toRgbString()
            });

            colors.push({
                name: `secondary_${shade}`,
                color: app.currentTheme.palette.getForeColor(`secondary_${shade}`, null, app.currentCanvas.getBackgroundColor()).toRgbString()
            });
        }

        if (this.props.showBackgroundAccent) {
            colors.push({
                name: "background_accent",
                color: app.currentTheme.palette.getForeColor("background_accent", null, app.currentCanvas.getBackgroundColor()).toRgbString()
            });
        }

        if (this.props.showAccentColors !== false) {
            _.each(app.currentTheme.palette.getSlideColors(), (color, key) => {
                colors.push({ name: key, color: color });
            });
        }

        if (this.props.omitColors) {
            colors = _.filter(colors, color => {
                return _.find(this.props.omitColors, omitColor => omitColor.name == color.name) == null;
            });
        }

        return (
            <div className="color_palette">
                {colors.map(color => (<ColorChit key={color.name} {...color} selected={color.name == this.props.selectedColor}
                    onClick={() => this.props.onSelect(color.name)}/>))}
            </div>
        );
    }
}

export class ColorChit extends Component {
    render() {
        let className = "color_chit";

        if (this.props.selected) {
            className += " selected";
        }

        if (this.props.name == "auto") {
            className += " auto";
        }

        let style = {
            color: this.props.color
        };

        return (
            <div className={className} onClick={this.props.onClick} style={style}>
                {/*<div className="background" style={style}></div>*/}
                {this.props.name == "auto" && <div className="auto">AUTO</div>}
            </div>
        );
    }
}
